<template>
    <div>
        <h1>Umsjá Dómsdags</h1>
        <hr>

        <ul>
            <li><router-link to="/dummy/episode/edit-meta">Breyta upplýsingum þáttar</router-link></li>
            <li><router-link to="/dummy/topic/add">Búa til umræðuefni</router-link></li>
        </ul>

        <!--<button v-on:click="signOut">Logout</button>-->
    </div>
</template>

<script>
    // import {db} from '../../main'
    //    import firebase from 'firebase'

    import AdminFooter from './AdminFooter.vue';

    export default {
        components: {AdminFooter},
        name: 'AdminMain'
//        ,
//        methods: {
//            signOut: function () {
//                firebase.auth().signOut().then(
//                    (user) => {
//                        this.$router.replace('/login');
//                    },
//                    (err) => {
//                        alert('Oops. ' + err.message)
//                    }
//                );
//            }
//        }
    }
</script>

<style scoped>
    h1 {
        font-weight: normal;
    }
    li {
        list-style: none;
        margin-top: 20px;
        font-size: 1.3em;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminMain.vue